import React from 'react'
import useGenericEndpoint from '../../hooks/api/useGenericEndpoint'
import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  List,
  ListItem,
  Typography,
} from '@mui/material'
import GenericLoadError from '../../common/GenericLoadError'
import { grey } from '@mui/material/colors'
import CustomerHeader from '../components/CustomerHeader'
import Tooltip from '../../common/Tooltip'
import { addTimezoneOffsetToTimestamp } from '../../utils/date'

const History = ({
  id,
  dropdowns,
  customerQuery,
  customerStatusTypesData,
  types,
  customerTicketsQuery,
}) => {
  const { isLoading, hasLoadError, data } = useGenericEndpoint(
    `/api/customer/${id}/history`,
    {
      shouldPreventCall: !id,
    }
  )

  const createdOnDisplay = addTimezoneOffsetToTimestamp(
    new Date(customerQuery.customer.createdOn)
  ).toLocaleDateString()

  return (
    <>
      <CustomerHeader
        customer={customerQuery.customer}
        customerStatusTypesData={customerStatusTypesData}
        customerTicketsQuery={customerTicketsQuery}
        types={types}
        tooltip={
          <Tooltip
            infoText={
              'Monitor the date of any instance when the account “Status Field” changes.'
            }
          />
        }
      />
      <Card>
        <CardContent>
          <Typography sx={{ fontSize: '20px', fontWeight: 'bold' }}>
            Account Status History
          </Typography>

          {hasLoadError && <GenericLoadError />}
          {isLoading && (
            <Box>
              <CircularProgress />
            </Box>
          )}

          <List>
            <ListItem>
              <b>{createdOnDisplay} -</b>&nbsp;Account Created
            </ListItem>
            {!isLoading &&
              !hasLoadError &&
              data.customerHistory.map((ch) => (
                <ListItem>
                  <b>{new Date(ch.createdOn).toLocaleDateString()}</b>&nbsp;-{' '}
                  {ch.note}
                </ListItem>
              ))}
          </List>

          {!data?.customerHistory?.length && (
            <Typography sx={{ color: grey[700], mt: 1, ml: 2 }}>
              <i>No history results for this account</i>
            </Typography>
          )}
        </CardContent>
      </Card>
    </>
  )
}

export default History
